import { createFileRoute } from '@tanstack/react-router';
import { P } from '@vagusx/shared';
import { ContactRulesPage } from '@/pages/campaigns/rules';
import { requireRoutePermission } from '@/lib/route-guard';

// Readable with outreach:view; saving needs outreach:edit, which the API enforces.
export const Route = createFileRoute('/_authenticated/campaigns/rules')({
  beforeLoad: () => requireRoutePermission(P.OUTREACH_VIEW),
  component: ContactRulesPage,
});
